import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

interface TabOption {
  title: string;
  value: number;
  width: number;
}

interface TabsComponentProps {
  options: TabOption[];
  selectedTab: TabOption;
  onTabChange: (tab: TabOption) => void;
}

const TabsComponent: React.FC<TabsComponentProps> = ({ options, selectedTab, onTabChange }) => (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={selectedTab.value} indicatorColor="primary" textColor="primary" aria-label={selectedTab.title}>
        {options.map((tab) => (
          <Tab
            key={tab.title}
            label={tab.title}
            value={tab.value}
            onClick={() => onTabChange(tab)}
            style={{
              textTransform: 'none',
              fontWeight: 'bold',
              background: '#DCE3E8',
            }}
          />
        ))}
      </Tabs>
    </Box>
  </Box>
);

export default TabsComponent;
